import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUserGroupTeams = (id) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['userGroupTeams', id],
    queryFn: async () => {
      const result = await restClient({
        url: `${prefix}/user-groups/${id}/teams`,
        method: 'get'
      });
      return result;
    },
    enabled: !!id, 
    staleTime: 0, 
    cacheTime:0, 
    refetchOnWindowFocus: false
  });
};
